(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["industry-section"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function(){
      $(".industry-slider").owlCarousel({
        margin:10,
        nav:true,
        navText: ["←","→"],

        responsive:{
          0:{
              items:1
          },
          600:{
              items:4
          },
          1000:{
              items:4
          }
        }
      });
    });

  } catch(e) { console.error(e); }
})();

})();
